var A11yToolInitializer, FixA11y;

A11yToolInitializer = require('grpn-fix-a11y/lib/initializer');

FixA11y = window.FixA11y != null ? window.FixA11y : window.FixA11y = {};

FixA11y.init = function(payload, done) {
  var fixA11y;
  fixA11y = payload.fixA11y;
  if (fixA11y == null) {
    return done();
  }
  A11yToolInitializer(fixA11y);
  return done();
};

module.exports = FixA11y;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvY29yZS9mcm9udGVuZC9zY3JpcHRzL3ZlbmRvcl9tb2R1bGVzL2ZpeC1hMTF5LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL2NvcmUvZnJvbnRlbmQvc2NyaXB0cy92ZW5kb3JfbW9kdWxlcy9maXgtYTExeS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxtQkFBQSxHQUFzQixPQUFBLENBQVEsK0JBQVI7O0FBRXRCLE9BQUEsNEJBQVUsTUFBTSxDQUFDLFVBQVAsTUFBTSxDQUFDLFVBQVc7O0FBRTVCLE9BQU8sQ0FBQyxJQUFSLEdBQWUsU0FBQyxPQUFELEVBQVUsSUFBVjtBQUNiLE1BQUE7RUFBQyxVQUFXO0VBQ1osSUFBcUIsZUFBckI7QUFBQSxXQUFPLElBQUEsQ0FBQSxFQUFQOztFQUNBLG1CQUFBLENBQW9CLE9BQXBCO1NBQ0EsSUFBQSxDQUFBO0FBSmE7O0FBTWYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
